<div class="app-content content">
  <div class="content-wrapper">
    <section class="row flexbox-container">
      <div class="col-12 d-flex align-items-center justify-content-center">
        <div class="col-lg-5 col-md-8 col-10 box-shadow-2 p-0">
          <div class="card border-grey border-lighten-3 px-1 py-1 m-0">
            <div class="card-header border-0">
              <div class="card-title text-center">
                <h4>Your subscription has expired</h4>
              </div>
            </div>
            <div class="card-content">
              <div class="card-body text-center">
                <div class="alert alert-warning" role="alert" *ngIf="daysRemaining !== null; else noGraceInfo">
                  You're in a grace period and can keep using your account for
                  <strong>{{ daysRemaining }}</strong> more day<span *ngIf="daysRemaining !== 1">s</span>.
                  Renew now to avoid any interruption.
                </div>
                <ng-template #noGraceInfo>
                  <div class="alert alert-warning" role="alert">
                    You're in a short grace period. Renew now to avoid any interruption.
                  </div>
                </ng-template>

                <button type="button" class="btn btn-outline-info btn-block" (click)="goToRenewal()">
                  Renew Now
                </button>
                <button type="button" class="btn btn-flat-secondary btn-block mt-1" (click)="continueToDashboard()">
                  Continue to Dashboard
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
